module.exports = __webpack_public_path__ + "img/wetApp.5e39d703.png";